import { Outlet } from "react-router-dom";
import { Stack, styled } from "@mui/material";

export const JobLayout = () => {
  return (
    <JobLayoutWrapper>
      <Outlet />
    </JobLayoutWrapper>
  );
};

const JobLayoutWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
